export class Menu {
    constructor() {
        let navItems = document.querySelectorAll(".mnav-list-item-top") as HTMLCollectionOf<HTMLElement>;
        let navItemGroups = document.querySelectorAll(".meganav-group") as HTMLCollectionOf<HTMLElement>;
        let headerNav = document.querySelector("#headerNav");
        let mainContainer = document.querySelector("main");
        let originalText: string[] = [];
        let timeId;

        // Nav will open after the user has hovered over a nav item
        // for half a second
        for (let i = 0; i < navItems.length; i++) {
            navItems[i].addEventListener("mouseenter", function () {
                timeId = setTimeout(function () {
                    for (let j = 0; j < navItemGroups.length; j++) { 
                        navItemGroups[j].classList.add("meganav-group-show");
                    }
                }, 500);
            })            
        }

        headerNav.addEventListener("mouseleave", function () {
            clearTimeout(timeId);
            for (let j = 0; j < navItemGroups.length; j++) {
                navItemGroups[j].classList.remove("meganav-group-show");
            }
        })

        // Adds margin to <main> if the desktop nav has increased its height
        // due to long nav item titles
        function addMargin() {           
            if (window.innerWidth > 960) {
                if (headerNav.clientHeight > 55) {
                    if (headerNav.clientHeight > 58) {
                        mainContainer.classList.add("main-margin-top");
                    }
                    else if (mainContainer.classList.contains("main-margin-top")) {
                        mainContainer.classList.remove("main-margin-top");
                    }   

                    // Will trim nav item titles if the title has broken into three lines
                    for (let i = 0; i < navItems.length; i++) {
                        originalText.push(navItems[i].querySelector("span").innerText)

                        if (navItems[i].querySelector("span").offsetHeight > 56) {
                            if (navItems[i].querySelector("span").innerText.length > 25) {                                
                                let newString = navItems[i].querySelector("span").innerText.substring(0, 23).trim() + "...";
                                navItems[i].querySelector("span").innerHTML = newString;
                                if (!navItems[i].querySelector("span").classList.contains("trimmed-text")) {
                                    navItems[i].querySelector("span").classList.add("trimmed-text");
                                }
                            }
                        }
                        else if (navItems[i].querySelector("span").classList.contains("trimmed-text") && navItems[i].querySelector("span").offsetHeight < 46) {
                            navItems[i].querySelector("span").innerHTML = originalText[i];
                            navItems[i].querySelector("span").classList.remove("trimmed-text");
                        }
                    }
                }         
            }
            else if (mainContainer.classList.contains("main-margin-top")) {
                mainContainer.classList.remove("main-margin-top");
            }        
        }

        addMargin();
        window.addEventListener("resize", addMargin);
    }
} 


// WEBPACK FOOTER //
// ./Static/javascript/modules/menu.ts